// TODO: delete "@ts-nocheck" after typing this file
// @ts-nocheck

import axios from "axios";
import { sendYMEvent } from "./services/YandexMetrika/YandexMetrika";
import { IYMPropsParams } from "./services/YandexMetrika/interfaces";

export default {
  getCookie(name) {
    const matches = document.cookie.match(
      new RegExp(
        `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1")}=([^;]*)`
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  },

  setCookie(name, value, props) {
    props = props || {};

    let exp = props.expires;
    if (!exp) {
      exp = new Date();
      exp.setFullYear(exp.getFullYear() + 10);
    }
    if (typeof exp === "number" && exp) {
      const d = new Date();
      d.setTime(d.getTime() + exp * 1000);
      exp = props.expires = d;
    }

    if (exp && exp.toUTCString) {
      props.expires = exp.toUTCString();
    }
    if (typeof value === "object") {
      value = JSON.stringify(value);
    }
    value = encodeURIComponent(value);
    let updatedCookie = `${name}=${value}`;

    for (const propName in props) {
      updatedCookie += `; ${propName}`;
      const propValue = props[propName];

      if (propValue !== true) {
        updatedCookie += `=${propValue}`;
      }
    }

    document.cookie = updatedCookie;
  },

  deleteCookie(name) {
    this.setCookie(name, null, { expires: -1 });
  },

  tryGetClientIdFromGa(trackingId) {
    if (!window.ga || !window.ga.getAll) {
      return false;
    }

    try {
      const trackers = window.ga.getAll();
      let i;
      let len;
      for (i = 0, len = trackers.length; i < len; i += 1) {
        if (!trackingId || trackers[i].get("trackingId") === trackingId) {
          return trackers[i].get("clientId");
        }
      }
    } catch (e) {
      // TODO: write error handler
    }
    return false;
  },

  getClientId(onSuccess, trackingId, onFailure) {
    if (!trackingId) {
      const gaCookie = this.getCookie("_ga");
      let match = false;
      if (gaCookie && (match = gaCookie.match(/^GA1\.2\.(.+$)/))) {
        onSuccess(match[1]);
        return match[1];
      }
    }

    let clientId;
    if ((clientId = this.tryGetClientIdFromGa())) {
      onSuccess(clientId);
      return clientId;
    }

    let cycles = 0;
    const context = this;
    const interval = setInterval(() => {
      if (
        (clientId = context.tryGetClientIdFromGa(trackingId) || cycles++ > 30)
      ) {
        clearInterval(interval);
        if (clientId) {
          onSuccess(clientId);
        } else {
          onFailure && onFailure();
        }
      }
    }, 100);
  },

  getTestGroup(
    testName,
    groups,
    firstEntryAttrs,
    srcDomain,
    onSuccess,
    onFailure
  ) {
    // try to get value from cookie
    const { inGetClientId } = window.frisbuy;

    if (inGetClientId) {
      setTimeout(() => {
        this.getTestGroup(
          testName,
          groups,
          firstEntryAttrs,
          srcDomain,
          onSuccess,
          onFailure
        );
      });
    } else {
      let testDataStr;
      let testData = {};

      window.frisbuy.inGetClientId = true;

      if ((testDataStr = this.getCookie("friSplitTest"))) {
        try {
          testData = JSON.parse(testDataStr);
        } catch (e) {
          testData = {};
        }

        if (testName in testData) {
          window.frisbuy.inGetClientId = false;
          onSuccess(testData[testName], testData[`${testName}_attrs`], false);
          return;
        }
      }

      // otherwise - we'll need clientID
      const context = this;
      this.getClientId(
        (clientId) => {
          let apiUrl = `${srcDomain}/fb/split?test=${testName}&client_id=${clientId}`;
          if (groups && groups.length > 0) {
            groups.forEach((group) => {
              apiUrl += `&groups[]=${group}`;
            });
          }
          if (firstEntryAttrs) {
            apiUrl += `&first_entry_attrs=${encodeURIComponent(
              firstEntryAttrs
            )}`;
          }
          axios
            .get(apiUrl)
            .then((response) => {
              const groupName = response.data.group;
              let groupAttrs = response.data.attributes;
              testData = testData || {};
              groupAttrs = groupAttrs || {};
              testData[testName] = groupName;
              testData[`${testName}_attrs`] = groupAttrs;
              context.setCookie("friSplitTest", testData);
              window.frisbuy.inGetClientId = false;
              onSuccess(groupName, groupAttrs, response.data.isFirstEntry);
            })
            .catch((error) => {
              // todo retry
              window.frisbuy.inGetClientId = false;
              console.log("Get group name error", error);
              onFailure && onFailure();
            });
        },
        null,
        onFailure
      );
    }
  },

  setGroupNameInGa(
    categoryPostfix,
    customerCode,
    splitTestName,
    groupName,
    trackerParamsObject,
    dimensionId,
    onComplete
  ) {
    function getParamsForGA() {
      const { embed_id, sku_id, skug_id, category_id } = trackerParamsObject;

      const params = {
        embed_id,
        sku_id,
        skug_id,
        category_id,
        stock: getStock(embed_id, sku_id),
      };

      return deleteEmptyFields(params);
    }

    if (trackerParamsObject.frisbuyTrackerId) {
      window.frisbuyGa4(
        "event",
        // `Frisbuy_${categoryPostfix}_${customerCode}`,
        `friSplit${splitTestName}_${groupName}`,
        {
          send_to: trackerParamsObject.frisbuyTrackerId,
          ...getParamsForGA(),
        }
      );
    }

    if (trackerParamsObject.clientTrackerId) {
      window.frisbuyGa4(
        "event",
        // `Frisbuy_${categoryPostfix}`,
        `friSplit${splitTestName}_${groupName}`,
        {
          send_to: trackerParamsObject.clientTrackerId,
          ...getParamsForGA(),
        }
      );
    }
    onComplete();

    function deleteEmptyFields(object) {
      for (const field in object) {
        if (
          !object[field] &&
          typeof object[field] !== "number" &&
          typeof object[field] !== "boolean"
        ) {
          delete object[field];
        }
      }

      return object;
    }
  },

  sendYMSplitTestEvent(
    counterId,
    splitTestName,
    groupName,
    trackerParamsObject: IYMPropsParams,
    onComplete
  ) {
    const action = `Split${splitTestName}_${groupName}`;
    const params: IYMPropsParams = trackerParamsObject;
    /*
      TODO: write handler on "stock" param if it need
      if (getStock(embed_id, sku_id)) {
        Object.assign(params, { stock: getStock(embed_id, sku_id) });
      }
    */

    sendYMEvent(counterId, action, params);

    onComplete();
  },
};

function getStock(embedId, skuId) {
  if (!embedId || !skuId) {
    return null;
  }

  const media = [];
  const linkList = [];

  let isAvailable = null;

  window.frisbuy[embedId].postList.forEach((post) => {
    if (post && post.media && post.media.length > 0) {
      media.push(...post.media);
    }
  });

  media.forEach((media) => {
    linkList.push(...media.linkList);
  });

  for (let i = 0; i < linkList.length; i++) {
    if (linkList[i].sku.offerId === skuId) {
      isAvailable = linkList[i].sku.isAvailable;

      break;
    }
  }

  return isAvailable;
}
